import React, { FC, useEffect, useState } from 'react'
import { RouteComponentProps } from "@reach/router"
import _ from 'lodash'
import Isvg from 'react-inlinesvg'
// Components
import { Toolbar } from "components/subnav"
import ImportIcon from "components/import-export/import-icon"
import ExportIcon from "components/import-export/export-icon"
import Import from "components/import-export/import"
import TMFreeRentTable from './tm-free-rent-table'
// Data
import api_match from "data/interface/api"
import freeRentService from "data/free-rent"
import propertyService from 'data/property.ts'
import importService from "data/import"
//Styles
import { TMFreeRent_s } from "components/tenant-market/free-rent/tm-free-rent-styles"
import { AddIcon } from "images/icons/tools"

const TMFreeRent: FC<RouteComponentProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [initSort, setInitSort] = useState<boolean>(false)
  const [showImport, toggleShowImport] = useState<boolean>(false)
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const tableId = "tm-free-rent-table"

  useEffect(() => {
    importService.stream().subscribe(data => {
      toggleShowImport(data['showImport'])
    })

    toggleShowImport(false);

    const freeRentSubscription = freeRentService.stream().subscribe(data => {
      api_match(
        data,
        init  => setData(init.value),
        ok    => {
          setData(ok.value)
        },
        err   => {
          setData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        setProperty(_.find(data.value, {propertyid: data.current}))
      }
      switch (data.state) {
        case 'ok':
          setPropertyId(data.current)
          break
      }
    })

    return function cleanup() {
      freeRentSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [initSort])

  useEffect(() => {
    if (_.isNil(propertyId)) return

    freeRentService.fetchFreeRent(propertyId)
    propertyService.fetchProperty(propertyId)

  }, [propertyId])

  const Add = () => {
    const defaults = property ? {...property['defaultsnameditem']} : {}
    return (
      <a onClick={() => freeRentService.create(propertyService.getStoredPropertyId(), defaults)}>
        <Isvg src={AddIcon} width="20px" />
      </a>
    )
  }

  return (
    <TMFreeRent_s>
      <Toolbar>
        <Add />
        <ImportIcon />
        <ExportIcon template="freerent" />
      </Toolbar>
      { showImport && <Import /> }
      { data && property && !showImport && <TMFreeRentTable tableId={tableId} data={data} defaults={{...property['defaultsnameditem']}} /> }
    </TMFreeRent_s>
  )
}

export default TMFreeRent
